import { apiClient } from "@/api/request";
import { monitorApi } from "@/api/monitor.api";

export interface ResourceMetrics {
  sandboxClassTotal: number;
  sandboxTotal: number;
  mcpClassTotal: number;
  mcpTotal: number;
  memoryTotal: number;
  memoryItemTotal: number;
  ragClassTotal: number;
  ragTotal: number;
  ragCollectionTotal: number;
  skillgroupClassTotal: number;
  skillgroupTotal: number;
  skillTotal: number;
}

export interface MetricsTimeRange {
  fromTimestamp: string;
  toTimestamp: string;
}

export interface InvocationMetrics {
  totalCalls: number;
  successfulCalls: number;
  failedCalls: number;
  totalTokens: number;
  inputTokens: number;
  outputTokens: number;
  sandboxRuns: number;
  sandboxDurationMs: number;
}

interface ResourceMetricsData {
  mcp_class_total?: number;
  mcp_total?: number;
  memory_total?: number;
  memory_item_total?: number;
  rag_class_total?: number;
  rag_total?: number;
  rag_collection_total?: number;
  skillgroup_class_total?: number;
  skillgroup_total?: number;
  skill_total?: number;
}

interface GetResourceMetricsResponse {
  data?: ResourceMetricsData;
}

interface OverviewMetricsData {
  sandbox_class_total?: number;
  sandbox_total?: number;
}

interface GetOverviewResponse {
  data?: OverviewMetricsData;
}

function metric(value: number | undefined): number {
  return typeof value === "number" && Number.isFinite(value) ? value : 0;
}

export const privateDashboardApi = {
  getResourceMetrics: async (): Promise<ResourceMetrics> => {
    const [resourceResponse, overviewResponse] = await Promise.all([
      apiClient.post<GetResourceMetricsResponse>("/v2/GetResourceMetrics", {}),
      apiClient.post<GetOverviewResponse>("/v2/GetOverview", {}),
    ]);
    const resourceData = resourceResponse.data.data;
    const overviewData = overviewResponse.data.data;
    if (!resourceData || !overviewData) {
      throw new Error("资源统计响应缺少 data");
    }

    return {
      sandboxClassTotal: metric(overviewData.sandbox_class_total),
      sandboxTotal: metric(overviewData.sandbox_total),
      mcpClassTotal: metric(resourceData.mcp_class_total),
      mcpTotal: metric(resourceData.mcp_total),
      memoryTotal: metric(resourceData.memory_total),
      memoryItemTotal: metric(resourceData.memory_item_total),
      ragClassTotal: metric(resourceData.rag_class_total),
      ragTotal: metric(resourceData.rag_total),
      ragCollectionTotal: metric(resourceData.rag_collection_total),
      skillgroupClassTotal: metric(resourceData.skillgroup_class_total),
      skillgroupTotal: metric(resourceData.skillgroup_total),
      skillTotal: metric(resourceData.skill_total),
    };
  },

  getInvocationMetrics: async (timeRange: MetricsTimeRange): Promise<InvocationMetrics> => {
    const [stats, sandbox] = await Promise.all([
      monitorApi.getMetrics(timeRange),
      monitorApi.getSandboxMetrics(timeRange),
    ]);
    return {
      totalCalls: stats.totalCalls,
      successfulCalls: stats.successCalls,
      failedCalls: stats.failedCalls,
      totalTokens: stats.totalTokens,
      inputTokens: stats.inputTokens,
      outputTokens: stats.outputTokens,
      sandboxRuns: sandbox.sandboxRuns,
      sandboxDurationMs: sandbox.sandboxDurationMs,
    };
  },
};
